<script setup lang="ts">
import { RouteName } from '@/router/models/route-name';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const route = useRoute();

const { t } = useI18n();

const isActive = (tabs: RouteName[]) => {
  if (!route.name) return false;
  return tabs.some((tab) => route.name === tab);
};
</script>

<template>
  <div>
    <nav>
      <ul>
        <li
          :class="{ 'is-active': isActive([RouteName.AdminProjectAndUsers]) }"
        >
          <router-link :to="{ name: RouteName.AdminProjectAndUsers }">
            {{ t('navigation.menu.adminProjectAndUsers') }}
          </router-link>
        </li>

        <li
          :class="{ 'is-active': isActive([RouteName.AdminSupplierInvoices]) }"
        >
          <router-link :to="{ name: RouteName.AdminSupplierInvoices }">
            {{ t('navigation.menu.adminDeliveryInvoices') }}
          </router-link>
        </li>

        <li :class="{ 'is-active': isActive([RouteName.AdminSuppliers]) }">
          <router-link :to="{ name: RouteName.AdminSuppliers }">
            {{ t('navigation.menu.adminSuppliers') }}
          </router-link>
        </li>

        <li :class="{ 'is-active': isActive([RouteName.AdminDocuments]) }">
          <router-link :to="{ name: RouteName.AdminDocuments }">
            {{ t('navigation.menu.adminDocuments') }}
          </router-link>
        </li>

        <!-- <li>
          <router-link :to="{ name: 'authtest' }">Authtest</router-link>
        </li> -->
      </ul>
    </nav>
  </div>
</template>

<style scoped lang="scss">
@use '@/assets/style/variables';

nav ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin-top: 1rem;
  margin-bottom: 2rem;
  gap: 1rem;

  font-weight: 500;
  font-size: 1rem;

  li:first-child a {
    padding-left: 0;
  }

  li.is-active a {
    color: var(--primary-color);
    border-bottom-color: var(--primary-color);
  }

  li:not(.is-active) a {
    border-bottom: none;
    color: var(--inactive-color);
  }
}

.placeholder-option {
  color: var(--inactive-color);
}
</style>
